import { CSS_PX_PER_PT } from '@messenger/consts'
import { EDITOR_FLOOR_CHARACTER_SEED } from '@messenger/lotus'

/** The frame height a new Lotus box starts at: one line of the floor's seed size. */
export const EDITOR_TEXT_BOX_SEED_HEIGHT_PX =
  EDITOR_FLOOR_CHARACTER_SEED.fontSizePt * CSS_PX_PER_PT
